export const setValueGenericWay = <T>(obj: T, key: keyof T, value: T[keyof T]) => {
  obj[key] = value
}
